export default __webpack_public_path__ + "32337812b4b04375346c026ab4c56ff9.png";